import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/Box";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState, useEffect } from "react";
import { format } from "date-fns";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TanggalDialog = ({ openTanggal, handleCloseTanggal, onDateSelect, onDateRangeChange }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (startDate && endDate) {
      const formattedStart = format(startDate, "yyyy-MM-dd");
      const formattedEnd = format(endDate, "yyyy-MM-dd");
  
      onDateRangeChange({ start: formattedStart, end: formattedEnd });
  
      // Menutup hanya jika dua-duanya valid
      handleCloseTanggal?.();
    } else {
      onDateRangeChange({ start: null, end: null });
    }
  }, [startDate, endDate]);

  const getDateRange = (label) => {
    const now = new Date();

    switch (label) {
      case "Semua Tanggal Transaksi":
        return "Tanggal";
      case "30 Hari Terakhir":
        return new Date(now.setDate(now.getDate() - 30))
          .toISOString()
          .split("T")[0];
      case "90 Hari Terakhir":
        return new Date(now.setDate(now.getDate() - 90))
          .toISOString()
          .split("T")[0];
      default:
        return "";
    }
  };

  const handleClick = (label) => {
    const dateValue = getDateRange(label);
    onDateSelect(dateValue);
  };

  const options = [
    "Semua Tanggal Transaksi",
    "30 Hari Terakhir",
    "90 Hari Terakhir",
  ];
  return (
    <Dialog
      fullScreen
      open={openTanggal}
      onClose={handleCloseTanggal}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseTanggal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Typography
          variant="body2"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
        >
          Tanggal
        </Typography>

        <>
          {options.map((label, idx) => (
            <Box
              key={idx}
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#ffffff",
                boxShadow: 1,
                mb: 1,
                cursor: "pointer",
              }}
              onClick={() => handleClick(label)}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                {label}
              </Typography>
            </Box>
          ))}
        </>
      </Box>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Typography variant="body2" color="text.primary" gutterBottom>
          Pilih Rentang Waktu
        </Typography>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Box>
            <Box
              display="flex"
              alignItems="center"
              sx={{
                mb: 2,
              }}
              gap={1}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Rentang Waktu
              </Typography>
              <CalendarTodayIcon
                sx={{ fontSize: 16, color: "text.secondary" }}
              />
            </Box>
          </Box>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
              display="flex"
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <DatePicker
                label="Mulai Dari"
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    },
                  },
                }}
              />
              <DatePicker
                label="Sampai"
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    },
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TanggalDialog;
